import { create } from 'zustand';
import axios from 'axios';

// Create an axios instance
const api = axios.create({
  baseURL: 'https://api.masark.co/',
  withCredentials: true, // Important for cookies to be sent
});


// Request interceptor to attach token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  err => Promise.reject(err)
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');

        const res = await axios.post(
          'https://api.masark.co/auth/refresh',
          { refreshToken },
          { withCredentials: true }
        );

        const { accessToken: newToken } = res.data;
        console.log("refreshToken set to:", newToken);

        localStorage.setItem('accessToken', newToken);
        console.log('accessToken set to:', newToken);

        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (err) {
        console.error('Refresh token failed or expired');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

const useAuthStore = create((set) => ({
  token: localStorage.getItem('accessToken') || null,
  setToken: (token) => set({ token }),
  user: null,
  loading: false,
  error: null,
  success: false,

  setUser: (user) => set({ user }),
  resetState: () => set({ loading: false, error: null, success: false }),

  login: async (formData) => {
    set({ loading: true, error: null, success: false });

    try {
      const res = await api.post('/auth/login', formData);
      const { accessToken, refreshToken } = res.data;

      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      // Call /users/me after login to get user info
      const userRes = await api.get('/users/me');
      const userData = userRes.data;
      localStorage.setItem('user', JSON.stringify(userData));

      set({
        token: accessToken,
        user: userData,
        loading: false,
        success: true
      });
    } catch (err) {
      set({
        error: err.response?.data?.message || 'Login failed',
        loading: false,
        success: false
      });
    }
  },



  // Method to add password after OAuth login
  addPassword: async (password) => {
    set({ loading: true, error: null });

    try {
      const accessToken = localStorage.getItem('accessToken');

      const response = await api.post(
        '/auth/add-password',
        { password },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      );

      if (response.data?.accessToken) {
        localStorage.setItem('accessToken', response.data.accessToken);
        set({ token: response.data.accessToken });
      }

      set({ loading: false, success: true });
      return response.data; // ✅ يرجع بيانات النجاح
    } catch (err) {
      console.error('Add password error:', err);

      set({
        error: err.response?.data?.message || 'Failed to add password',
        loading: false,
        success: false
      });

      throw err.response?.data || { message: 'Unknown error' };
    }
  },




  register: async (formData) => {
    set({ loading: true, error: null, success: false });

    try {
      const response = await api.post('/auth/register', formData);

      const { accessToken, refreshToken } = response.data;

      // ✅ Save tokens to localStorage
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);

      console.log('Registration response:', response.data);

      set({ loading: false, success: true });
      return true;
    } catch (err) {
      console.error('Registration error:', err);
      set({
        error: err.response?.data?.message || 'Registration failed',
        loading: false,
        success: false
      });
      return false;
    }
  },

  logout: async () => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      if (!accessToken) throw new Error('No access token found');

      await api.get('/auth/logout', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      set({ token: null, user: null, success: false });
    }
  },

  isLoggedIn: () => {
    const token = localStorage.getItem('accessToken');
    return !!token;
  },

  initAuth: async () => {
    // const token = localStorage.getItem('accessToken');
    // if (!token) return false;

    // try {
    //   const res = await api.get('/auth/me', {
    //     headers: { Authorization: `Bearer ${token}` }
    //   });
    //   set({ user: res.data, token });
    //   return true;
    // } catch (err) {
    //   localStorage.removeItem('accessToken');
    //   set({ token: null, user: null });
    //   return false;
    // }

    const token = localStorage.getItem('accessToken');
    const user = JSON.parse(localStorage.getItem('user'));
    if (!token || !user) return false;

    set({ token, user });
    return true;
  }

}));

export default useAuthStore;
